<template>
  <aside :class="{ 'filters-desktop': !mobile }">
    <h3 class="filters-title">
      <span class="filter-icon"></span> 
    </h3>

    <div v-if="loading && productIds?.length">
    </div>

    <div v-else-if="!productIds?.length">
    </div>

    <div v-else>

      <!-- ==adsdasdasdsad============ -->
      <!-- 1) DEPARTAMENTO (INFO) -->
      <!-- =========================== -->
      <div class="filter-group" v-if="filtros.departamentos?.length">
        <div class="filter-header">Departamento</div>
        <ul>
          <li>
            <label class="filter-option disabled">
              <input type="checkbox" checked disabled />
              <span>{{ formatText(selected.departamento) }}</span>
            </label>
          </li>
        </ul>
      </div>

      <!-- =========================== -->
      <!-- 2) CATEGORÍA (INFO) -->
      <!-- =========================== -->
      <div class="filter-group" v-if="filtros.categorias?.length">
        <div class="filter-header">Categoría</div>
        <ul>
          <li>
            <label class="filter-option disabled">
              <input type="checkbox" checked disabled />
              <span>{{ formatText(selected.categoria) }}</span>
            </label>
          </li>
        </ul>
      </div>

      <!-- =========================== -->
      <!-- 3) SUBCATEGORÍA -->
      <!-- =========================== -->
      <div class="filter-group" v-if="filtros.subcategorias?.length">
        <div class="filter-header">Subcategoría</div>

        <ul>
          <li
            v-for="sub in filtros.subcategorias"
            :key="sub"
          >
            <label class="filter-option">
              <input
                type="radio"
                name="subcategoria"
                :checked="isSelected('subcategoria', sub)"
                @change="selectFilter('subcategoria', sub)"
              />
              <span>{{ formatText(sub) }}</span>
            </label>
          </li>
        </ul>
      </div>

      <!-- =========================== -->
      <!-- 4) MARCA -->
      <!-- =========================== -->
      <div class="filter-group" v-if="filtros.marcas?.length">
        <div class="filter-header">Marca</div>

        <ul>
          <li
            v-for="m in filtros.marcas"
            :key="m"
          >
            <label class="filter-option">
              <input
                type="radio"
                name="marca"
                :checked="isSelected('marca', m)"
                @change="selectFilter('marca', m)"
              />
              <span>{{ formatText(m) }}</span>
            </label>
          </li>
        </ul>
      </div>

    </div>
  </aside>
</template>

<script>
import axios from "axios";
import baseUrl from "@/api";

export default {
  name: "FiltersSidebar",

  props: {
    defaultFilters: Object,
    mobile: Boolean,
    productIds: Array
  },

  data() {
    return {
      filtros: {
        departamentos: [],
        categorias: [],
        subcategorias: [],
        marcas: []
      },
      loading: true,
      filtrosCargados: false, // ✅ CLAVE
      selected: {
        departamento: "",
        categoria: "",
        subcategoria: "",
        marca: ""
      }
    };
  },

  watch: {
    // 🔥 CARGAR FILTROS SOLO CUANDO YA HAY PRODUCTOS (UNA SOLA VEZ)
    productIds: {
      immediate: true,
      handler(ids) {
        if (!this.filtrosCargados && Array.isArray(ids) && ids.length) {
          this.filtrosCargados = true;
          this.loadFilters();
        }
      }
    },

    defaultFilters: {
handler(n = {}) {
  this.selected.departamento = n.departamento || "";
  this.selected.categoria = n.categoria || "";
},
      immediate: true
    }
  },

  methods: {
    normalize(v) {
      return String(v || "").trim().toLowerCase();
    },

    async loadFilters() {
      this.loading = true;
      try {
        const res = await axios.get(`${baseUrl}/shopify/filters`, {
          params: { productIds: this.productIds.join(",") }
        });

        this.filtros = {
          departamentos: res.data.departamentos || [],
          categorias: res.data.categorias || [],
          subcategorias: res.data.subcategorias || [],
          marcas: res.data.marcas || []
        };

      } catch (e) {
        console.error("❌ Error cargando filtros:", e);
      } finally {
        this.loading = false;
      }
    },

    selectFilter(tipo, valor) {
      if (tipo === "departamento" || tipo === "categoria") return;

      this.selected[tipo] = valor;

      this.$emit("filter-selected", {
        subcategoria: this.selected.subcategoria || null,
        marca: this.selected.marca || null
      });
    },

    isSelected(tipo, valor) {
      return this.normalize(this.selected[tipo]) === this.normalize(valor);
    },

    formatText(text) {
      return text
        ?.replace(/-/g, " ")
        .split(" ")
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ");
    }
  }
};
</script>

<style scoped>
.filters-desktop {
  width: 240px;
  background: #fff;
  padding: 10px 0;
  border-right: 1px solid #ddd;
}

.filter-header {
  padding: 12px;
  cursor: pointer;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  color: #444;
}

.filter-group ul {
  list-style: none;
  padding-left: 12px;
}

.filter-group li {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  font-size: 0.9rem;
}

.filter-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.filter-group li.active span {
  color: #0085ff;
  font-weight: bold;
}

input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #0085ff;
}
</style>
